import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import subStorageService from '../../services/SubStorageService';
import SubStorageEditorTemplate from './SubStorageEditorTemplate';
import {useTitle} from '../dashboard/TitleContext';

const SubStorageEditor = () => {

    const [id] = useState(
        window.location.pathname.split('/')[4] === 'create'
            ? undefined
            : window.location.pathname.split('/')[4]
    );

    useTitle([
        {name: 'Alraktár Lista', url: '/dashboard/storage/substorages'},
        {name: 'Alkraktár', url: '/dashboard/storage/substorages/' + (id || 'create')}
    ])

    const [subStorage, setSubStorage] = useState({
        name: "",
        createdAt: "",
        updatedAt: ""
    });

    const [message, setMessage] = useState('');

    const navigate = useNavigate()

    useEffect(() => {
        if (!id) return
        subStorageService.findById(id)
            .then(response => setSubStorage((prevSubStorage) => ({
                ...prevSubStorage,
                ...response,
            })))
            .catch(error => console.error(error));
    }, [id]);

    const onChange = (event) => {
        const {name, value} = event.target;
        setSubStorage((prevSubStorage) => ({
            ...prevSubStorage,
            [name]: value,
        }));
    };

    const create = (e) => {
        e.preventDefault();
        subStorageService.createSubStorage(subStorage)
            .then(() => navigate('/dashboard/storage/substorages'))
            .catch(error => setMessage(error.message))
    };

    const update = (e) => {
        e.preventDefault();
        subStorageService.updateSubStorage(id)
            .then(() => navigate('/dashboard/storage/substorages'))
            .catch(error => setMessage(error.message))
    };

    return (
        <SubStorageEditorTemplate
            data={{
                id,
                subStorage,
                message,
                onChange,
                create,
                update,
            }}
        />
    );
};

export default SubStorageEditor;
